// extracted by mini-css-extract-plugin
export default {"img-wrap":"img-wrap___CAruk","height":"height___kKRTD"};